/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DocumentKind } from './documentKind';

/**
 * Single PDF document.
 */
export interface Document {
  documentKind?: DocumentKind;
  /**
   * Single PDF document. Intended for document download at presentation layer.  Format is PDF document as byte stream in Base64 encoding.
   */
  documentContent?: string;
}
export namespace Document {}
